import { Input, Menu, Loader, IconDeclined, Card, Button } from 'cdk-radial';
import styled from 'styled-components';

export const StyledHeaderReconcileReport = styled.div`
  width: 100%;
`;

export const StyledColumnFilterPlaceHolder = styled.div`
  display: flex;
  justify-content: right;
`;
export const CoulmnFilterContainer = styled.div`
  width: 224px;
`;

export const StyledInput = styled(Input)`
  caretcolor: transparent;
`;

export const StyledMenu = styled(Menu)`
  width: 224px;
`;

export const StyledCard = styled(Card)`
  flex: 1;
  display: flex;
  padding-bottom: 0;
  box-shadow: none;
`;

export const StyledLoader = styled(Loader)`
  padding: 10px;
`;

export const StyledVoidPaymentLabelAndValue = styled.div`
  margin: 0 0 2px;
`;

export const StyledVoidPaymentContent = styled.span`
  color: rgba(21, 27, 37, 0.701961);
  font-size: 0.8rem;
`;

export const StyledVoidMessageContent = styled.div`
  margin: 10px 0 16px;
  font-size: 0.8rem;
`;

export const StyledVoidDocumentIdContent = styled.div`
  margin: 20px 0 2px;
  font-weight: 500;
`;

export const StyledVoidPaymentDialog = styled.div`
  width: 28rem;
`;

export const StyledIconDeclined = styled(IconDeclined)`
  fill: #006cfa;
  cursor: pointer;
`;

export const StyledSaveButton = styled(Button)`
  width: 9em;
`;

export const StyledReconciledHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledPayablesSelected = styled.span`
  color: var(--text-icons-light-enabled-dark-70, rgba(0, 0, 0, 0.7));
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin: 0.7em 1em 0 0;
`;

export const StyledToast = styled.div`
  max-width: 35rem;
  width: 35rem;
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
`;

export const StyledContent = styled.div`
  display: inline;
`;

export const StyledBullets = styled.li`
  margin-left: 1rem;
`;

export const StyledReconcileDatePickerChip = styled.div`
  height: 2.3rem;
  margin-top: 0.4rem;
  .CalendarMonth_caption {
    height: 35px;
  }
`;
